import axios from 'axios';
import { API_URL, GYPSYBALL_PYTHON_API_URL } from 'configs';
import { isEmpty } from 'lodash';
import uuid from 'uuid/v1';

export const WORKSPACE_REQUEST = 'WORKSPACE_REQUEST';
export const WORKSPACE_SUCCESS = 'WORKSPACE_SUCCESS';
export const WORKSPACE_VALIDATION_ERROR = 'WORKSPACE_VALIDATION_ERROR';
export const SHOW_SNACKBAR = 'SHOW_SNACKBAR';
export const HIDE_WORKSPACE_FEILD_VALIDATION_ERROR =
  'HIDE_WORKSPACE_FEILD_VALIDATION_ERROR';
export const REDIRECT_TO_WORKSPACE_LIST = 'REDIRECT_TO_WORKSPACE_LIST';
export const REDIRECT_TO_WORKSPACE_CONFIGURATION_LIST ="REDIRECT_TO_WORKSPACE_CONFIGURATION_LIST";
export const WORKSPACE_GET_SUCCESS = 'WORKSPACE_GET_SUCCESS';
export const WORKSPACE_DROPDOWN_LIST_SUCCESS =
  'WORKSPACE_DROPDOWN_LIST_SUCCESS';
export const WORKSPACE_SERVER_SUCCESS = 'WORKSPACE_SERVER_SUCCESS';
export const CHAT_GET_LLM_MODEL_SUCCESS = 'CHAT_GET_LLM_MODEL_SUCCESS';
export const CHAT_GET_LLM_PROMPTS_SUCCESS ='CHAT_GET_LLM_PROMPTS_SUCCESS';
const SHOW_LOADER = 'SHOW_LOADER';
const HIDE_LOADER = 'HIDE_LOADER';

//attachment consts
export const WORKSPACE_ATTACHMENT_VALIDATION_ERROR =
  'WORKSPACE_ATTACHMENT_VALIDATION_ERROR';
export const WORKSPACE_ATTACHMENT_SUCCESS = 'WORKSPACE_ATTACHMENT_SUCCESS';

export const WORKSPACE_FORM_VALIDATION_ERROR =
  'WORKSPACE_FORM_VALIDATION_ERROR';

  export const WORKSPACE_FORM_SUCCESS = 'WORKSPACE_FORM_SUCCESS';

const showCommonLoader = (label = '') => ({
  type: SHOW_LOADER,
  common_loder_label: label
});
const hideCommonLoader = () => ({
  type: HIDE_LOADER
});

const workspaceRequest = () => ({
  type: WORKSPACE_REQUEST
});

export const workspaceServerListSuccess = () => ({
  type: WORKSPACE_SERVER_SUCCESS
});

const workspaceListSuccess = workspaceList => ({
  type: WORKSPACE_SUCCESS,
  workspaceList: workspaceList
});

const workspaceFailure = notification => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: 'general_error'
});

const validationError = notification => ({
  type: WORKSPACE_VALIDATION_ERROR,
  validation_error: notification
});
const tokenError = notification => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: 'token_expire'
});



const workspaceConfigurationSuccess = (message , action , dispatch) => {
  dispatch(WorkspaceConfigurationSuccessNotification(message));
  dispatch(redirectToWorkspaceConfigurationList());
}

  export const redirectToWorkspaceConfigurationList = () => ({
    type:REDIRECT_TO_WORKSPACE_CONFIGURATION_LIST
  })

  const workspaceAddUpadteSuccess = (message, action, dispatch) => {
    dispatch(workspaceSuccessNotification(message));
    dispatch(redirectToWorkspaceList());
  };

export const redirectToWorkspaceList = () => ({
  type: REDIRECT_TO_WORKSPACE_LIST
});

const getWorkspaceSuccess = (response, action) => ({
  type: WORKSPACE_GET_SUCCESS,
  record: response,
  actionType: action
});

const workspaceSuccessNotification = message => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: message,
  snackbar_notification_type: 'success'
});
const WorkspaceConfigurationSuccessNotification =message => ({
  type:SHOW_SNACKBAR,
  snackbar_notification: message,
  snackbar_notification_type: 'success'
});

export const hideWorkspaceValidationError = feild_key => ({
  type: HIDE_WORKSPACE_FEILD_VALIDATION_ERROR,
  feild_key: feild_key
});

export const workspaceListFetch = (object_viewed_id = '') => {
  var token = localStorage.getItem('token');
  return dispatch => {
    dispatch(workspaceRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + 'workspace/getAll', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: 'Bearer ' + token
      },
      params: { object_viewed_id: object_viewed_id }
    }).then(
      response => {
        dispatch(hideCommonLoader());
        dispatch(workspaceListSuccess(response.data));
      },
      error => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};




export const addWorkspace = data => {
  var token = localStorage.getItem('token');
  return dispatch => {
    dispatch(workspaceRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + 'workspace/create', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: 'Bearer ' + token
      },
      data: data
    }).then(
      response => {
        dispatch(hideCommonLoader());
        workspaceAddUpadteSuccess(
          'Workspace Added Successfully',
          'create',
          dispatch
        );
      },
      error => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};


export const updateWorkspaceConfiguration = data => {  
  var token = localStorage.getItem('token');
  return dispatch => {
    dispatch(workspaceRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + 'workspace/updateWorkspaceConfiguration', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: 'Bearer ' + token
      },
      data: data
    }).then(
      response => {
        dispatch(hideCommonLoader());
        workspaceAddUpadteSuccess(
          'Workspace Configuration Done Successfully',
          'create',
          dispatch
        );
      },
      error => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

export const updateWorkspace = data => {
  var token = localStorage.getItem('token');
  return dispatch => {
    dispatch(workspaceRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + 'workspace/update/' + data.id, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: 'Bearer  ' + token
      },
      data: data
    }).then(
      response => {
        dispatch(hideCommonLoader());
        workspaceAddUpadteSuccess(
          'Workspace Updated Successfully',
          'update',
          dispatch
        );
      },
      error => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

export const getWorkspaceById = (id, action) => {
  var token = localStorage.getItem('token');
  return dispatch => {
    dispatch(workspaceRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + 'workspace/getById/' + id, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: 'Bearer  ' + token
      }
    }).then(
      response => {
        dispatch(hideCommonLoader());
        dispatch(getWorkspaceSuccess(response.data, action));
      },
      error => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

export const deleteWorkspace = (workspaceId, object_viewed_id, user_id,workspace) => {
  var token = localStorage.getItem('token');
  return dispatch => {

    dispatch(workspaceRequest());
    dispatch(showCommonLoader());
    
    return axios(API_URL + 'workspace/delete/' + workspaceId, { 
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: 'Bearer ' + token
      },
      data: {
        object_viewed_id
      }
    }).then(
      response => {
        dispatch(hideCommonLoader());
        dispatch(
          workspaceSuccessNotification('Workspace deleted successfully')
        );

       
   axios(GYPSYBALL_PYTHON_API_URL + 'delete/workspace', {
          method: 'POST',
           withCredentials: false,
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
           
          },
         
          data: {
            workspace,
         
          
          }
        });

        
        axios(GYPSYBALL_PYTHON_API_URL + 'delete/chathistory', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
           
          },
          // withCredentials: false,
          data: {
            user_id,
            workspace
          }
        });

      },
      error => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};



/*
 * Workspace dropdown list fetch methods
 */
const workspaceDropdownListSuccess = workspaceDropdownList => ({
  type: WORKSPACE_DROPDOWN_LIST_SUCCESS,
  workspaceDropdownList: workspaceDropdownList
});

export const workspaceDropdownListFetch = (user_id,object_viewed_id = '') => {
  var token = localStorage.getItem('token');
  return dispatch => {
    dispatch(workspaceRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + 'workspace/getAllForDropdown', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: 'Bearer ' + token
      },
      params: {
         object_viewed_id: object_viewed_id ,
         user_id :user_id
        }
    }).then(
      response => {
        dispatch(workspaceDropdownListSuccess(response.data));
        dispatch(hideCommonLoader());
      },
      error => {
        handleErrorResponse(error, dispatch);
        dispatch(hideCommonLoader());
      }
    );
  };
};

/*
 * attachment  methods
 */
export const uploadWorkspaceAttachments = data => {
  var token = localStorage.getItem('token');
  let workspace_id = data.get('id');
  return dispatch => {
    dispatch(workspaceRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + 'workspace/uploadAttachments/' + workspace_id, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: 'Bearer  ' + token
      },
      data: data
    }).then(
      response => {
        dispatch(hideCommonLoader());
        dispatch(
          workspaceSuccessNotification('Attachments Uploaded Successfully')
        );
        //dispatch(redirectToWorkspacesList())
      },
      error => {
        dispatch(hideCommonLoader());
        handleAttachmentErrorResponse(error, dispatch);
      }
    );
  };
};

export const getAttachmentsByWorkspaceId = id => {
  var token = localStorage.getItem('token');
  return dispatch => {
    dispatch(showCommonLoader());
    dispatch(workspaceRequest());
    return axios(API_URL + 'workspace/getAttachments/' + id, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: 'Bearer  ' + token
      }
    }).then(
      response => {
        dispatch(getAttachmentSuccess(response.data));
        dispatch(hideCommonLoader());
      },
      error => {
        handleErrorResponse(error, dispatch);
        dispatch(hideCommonLoader());
      }
    );
  };
};

export const deleteWorkspaceAttachment = (id, object_viewed_id) => {
  var token = localStorage.getItem('token');
  return dispatch => {
    dispatch(workspaceRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + 'workspace/deleteAttachment/' + id, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: 'Bearer ' + token
      },
      data: {
        object_viewed_id
      }
    }).then(
      response => {
        dispatch(hideCommonLoader());
        dispatch(
          workspaceSuccessNotification('Attachment deleted successfully')
        );
      },
      error => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

export const uploadWorkspaceForm = (data) => {
  console.log('workspace_form_data', data);
  var token = localStorage.getItem('token');
  let workspace_id = data.id;

  return (dispatch) => {
    dispatch(workspaceRequest());
    dispatch(showCommonLoader());

    axios(API_URL + 'workspace/uploadForm/' + workspace_id, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: 'Bearer ' + token
      },
      data: data
    }).then(
      response => {
        dispatch(hideCommonLoader());
        dispatch(workspaceSuccessNotification('Workspace Form Uploaded Successfully'));
        // dispatch(redirectToWorkspacesList())
      },
      error => {
        dispatch(hideCommonLoader());
        handleWorkspaceFormErrorResponse(error, dispatch);
      }
    );

    axios(GYPSYBALL_PYTHON_API_URL + '/upload/clientoutcomesheet', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      data: JSON.stringify({
        client_name: data.client_name,
        client_customer_nature: data.client_customer_nature,
        account_managers: data.account_managers,
        industry: data.industry,
        sub_industries: data.sub_industries,
        operations_resources: data.operations_resources,
        location_service: data.location_service,
        signup_year: data.signup_year,
        client_does: data.client_does
      })
    });
  };
};


export const getWorkspaceFormByWorkspaceId = id => {
  var token = localStorage.getItem('token');
  return dispatch => {
    dispatch(showCommonLoader());
    dispatch(workspaceRequest());
    return axios(API_URL + 'workspace/getWorkspaceForm/' + id, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: 'Bearer  ' + token
      }
    }).then(
      response => {
        dispatch(getWorkspaceFormSuccess(response.data));
        dispatch(hideCommonLoader());
      },
      error => {
        handleErrorResponse(error, dispatch);
        dispatch(hideCommonLoader());
      }
    );
  };
}

export const deleteWorkspaceForm = (id, object_viewed_id) => {
  var token = localStorage.getItem('token');
  return dispatch => {
    dispatch(workspaceRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + 'workspace/deleteWorkspaceForm/' + id, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: 'Bearer ' + token
      },
      data: {
        object_viewed_id
      }
    }).then(
      response => {
        dispatch(hideCommonLoader());
        dispatch(
          workspaceSuccessNotification('Workspace Form deleted successfully')
        );
      },
      error => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};


const getAttachmentSuccess = response => ({
  type: WORKSPACE_ATTACHMENT_SUCCESS,
  workspaceAttachmentList: response
});

const attachmentValidationError = notification => ({
  type: WORKSPACE_ATTACHMENT_VALIDATION_ERROR,
  attachment_validation_error: notification
});

const getWorkspaceFormSuccess = response => ({
  type: WORKSPACE_FORM_SUCCESS,
  workspaceFormList: response
});


const WorkspaceFormValidationError = notification => ({
  type: WORKSPACE_FORM_VALIDATION_ERROR,
  workspace_form_validation_error: notification
});

const handleAttachmentErrorResponse = (error, dispatch) => {
  try {
    if (error.response.status === 422 && error.response.data.error) {
      dispatch(attachmentValidationError(error.response.data.error));
    } else if (error.response.status === 401 && error.response.data.error) {
      dispatch(tokenError(error.response.data.error.toString()));
    } else {
      let err = '';
      if (error.response.data.error) {
        err = error.response.data.error.toString();
      } else {
        err = error.response.status + ` ` + error.response.statusText;
      }
      dispatch(workspaceFailure(err));
    }
  } catch (e) {
    dispatch(workspaceFailure('Unable to perform action.Something went wrong'));
  }
};

const handleWorkspaceFormErrorResponse = (error, dispatch) => {
  try {
    if (error.response.status === 422 && error.response.data.error) {
      dispatch(WorkspaceFormValidationError(error.response.data.error));
    } else if (error.response.status === 401 && error.response.data.error) {
      dispatch(tokenError(error.response.data.error.toString()));
    } else {
      let err = '';
      if (error.response.data.error) {
        err = error.response.data.error.toString();
      } else {
        err = error.response.status + ` ` + error.response.statusText;
      }
      dispatch(workspaceFailure(err));
    }
  } catch (e) {
    dispatch(workspaceFailure('Unable to perform action.Something went wrong'));
  }
};


export const updateWorkspaceContext = data => {
  var token = localStorage.getItem('token');
  return dispatch => {
    dispatch(workspaceRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + 'workspace/updateContext', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: 'Bearer  ' + token
      },
      data: data
    }).then(
      response => {
        dispatch(hideCommonLoader());
        dispatch(
          workspaceSuccessNotification('Workspace Context Updated Successfully')
        );
      },
      error => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

// handling error reponse
const handleErrorResponse = (error, dispatch) => {
  try {
    if (error.response.status === 422 && error.response.data.error) {
      dispatch(validationError(error.response.data.error));
    } else if (error.response.status === 401 && error.response.data.error) {
      dispatch(tokenError(error.response.data.error.toString()));
    } else {
      let err = '';
      if (error.response.data.error) {
        err = error.response.data.error.toString();
      } else {
        err = error.response.status + ` ` + error.response.statusText;
      }
      dispatch(workspaceFailure(err));
    }
  } catch (e) {
    dispatch(workspaceFailure('Unable to perform action.Something went wrong'));
  }
};

// chat with workspace
export const chatWithContext = (
  context_file,
  user_question,
  messages,
  setMessages
) => {
  return dispatch => {
    dispatch(showCommonLoader());
    return axios('https://gypsyball-python.azurewebsites.net/chat', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      data: JSON.stringify({
        context_blob_name: context_file,
        user_question: user_question
      })
    }).then(
      response => {
        dispatch(hideCommonLoader());
        setMessages(prevState => ({
          ...prevState,
          messages: [
            ...prevState.messages,
            {
              id: uuid(),
              sender: {
                authUser: false
              },
              content: response.data.chatbot_response.replace(/\n/g, '<br>')
            }
          ]
        }));
      },
      error => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

// chat with workspace
export const chatWithContextV2 = (
  session_id,
  workspace,
  user_question,
  messages,
  setMessages
) => {
  return dispatch => {
    dispatch(showCommonLoader());
    return axios(GYPSYBALL_PYTHON_API_URL + 'anthropic/test/msg', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      data: JSON.stringify({
        session_id: session_id,
        question: user_question,
        workspace: workspace
      })
    }).then(
      response => {
        dispatch(hideCommonLoader());
        setMessages(prevState => ({
          ...prevState,
          messages: [
            ...prevState.messages,
            {
              id: uuid(),
              sender: {
                authUser: false
              },
              content: response.data.answer.replace(/\n/g, '<br>')
            }
          ]
        }));
      },
      error => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

export const chatWithContextV3 = (
  session_id,
  workspace,
  llmModelValue,
  user_question,
  messages,
  setMessages,
  allowedExcelRowsValue,
  setllmPromptsValue,
  generalRules,
  userId
 
) => {
  return dispatch => {
    dispatch(showCommonLoader());
    return axios(GYPSYBALL_PYTHON_API_URL + 'llm/msg', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      data: JSON.stringify({
        session_id: session_id,
        question: !isEmpty(user_question)? user_question : '',
        workspace: !isEmpty(workspace)? workspace: '',
        llm: !isEmpty(llmModelValue)? llmModelValue: '',
        k: isNaN(parseInt(allowedExcelRowsValue))? 0 : allowedExcelRowsValue ,
        system_msg: !isEmpty(generalRules)? generalRules: '',
        length_of_answer: !isEmpty(setllmPromptsValue)? setllmPromptsValue : '',
        user_id:!isEmpty(userId)? userId: '',
       
      })
    }).then(
      response => {
        dispatch(hideCommonLoader());
        setMessages(prevState => ({
          ...prevState,
          messages: [
            ...prevState.messages,
            {
              id: uuid(),
              sender: {
                authUser: false
              },
              content: response.data.answer.replace(/\n/g, '<br>')
            }
          ]
        }));

       
      },
      error => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};




const getLLMModelsSuccess = llmList => ({
  type: CHAT_GET_LLM_MODEL_SUCCESS,
  llmList: llmList
});

const getLLMPromptsSuccess = llmPrompts => ({
  type: CHAT_GET_LLM_PROMPTS_SUCCESS,
  llmPrompts: llmPrompts
});
export const getLLMModels = () => {
  return dispatch => {
    dispatch(showCommonLoader());
    return axios(GYPSYBALL_PYTHON_API_URL + 'llm/list', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      }
    }).then(
      response => {
        dispatch(hideCommonLoader());
        dispatch(getLLMModelsSuccess(response.data.llm));
      },
      error => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

export const getLLMPrompts = () => {
  return dispatch => {
    dispatch(showCommonLoader());
    return axios(GYPSYBALL_PYTHON_API_URL + 'llm/prompts', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      }
    }).then(
      response => {
        dispatch(hideCommonLoader());
      
        dispatch(getLLMPromptsSuccess(response.data.prompts));
      },
      error => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

